import { ErrorMessage } from "formik";
import React, { Component } from "react";
import UploadBrowseFile from "../../components/BrowseFile/uploadBrowseFile.component";
import Input from "../../components/Input/input.component";
import { numberMask } from "../../components/Input/Masks";
import WidgetModalForm, {
	ModalFormContext
} from "../../components/Modal/modalForm.component";
import Required from "../../components/Required/required.component";
import SelectMulti from "../../components/SelectMulti/selectmulti.component";
import estoqueService from "../../services/estoqueService";
import UploadService from "../../services/uploadService";
import {
	SaidaEventoValidationSchema,
	SaidaNaoEventoValidationSchema
} from "./saida.modal.validates";

export default class SaidaModal extends Component {
	/* Modal de cadastro para saida de bens de consumo */
	constructor(props) {
		super(props);
		this.state = {
			validationSchema: {},
			estoque: {
				id: "",
				isEvento: undefined,
				ocorrencia: {
					id: 0
				},
				quantidadeSaida: "",
				motivo: "",
				documento: ""
			},
			ocorrenciaSelecionadaId: 0,
			tipoEstoqueSelecionadoId: 0,
			quantidadeSaida: "",
			municipio: "",
			saldo: "",
			dataEvento: "",
			ocorrencias: [],
			estoques: [],
			files: []
		};
	}

	async componentDidMount() {
		const ocorrenciasResponse = await estoqueService.findAllOcorrencias();
		const estoquesResponse = await estoqueService.findByDacaId(
			this.props.dacaId
		);
		this.setState({ ocorrencias: [...ocorrenciasResponse.data] });
		this.setState({ estoques: [...estoquesResponse.data] });
		this.setState({ validationSchema: SaidaEventoValidationSchema });
	}

	/*
		Função para mudar o tipo de oficio, não foi usado setFieldValue,
		e sim um handleChange, pois ao atualizar o estado em qualquer handleChange,
		o tipoOficio era perdido, e sumiam os componentes dependentes dessa váriavel
	*/
	onChangeTipoOficio(event) {
		const newState = this.state;
		newState.estoque.isEvento = event.target.value;

		this.setState(newState);

		/*
			Condicional para saber qual validação será usada
		*/
		if (event.target.value === "true") {
			this.setState({ validationSchema: SaidaEventoValidationSchema });
		} else {
			this.setState({ validationSchema: SaidaNaoEventoValidationSchema });
		}
	}

	handlePosUploadAction = (documento, values) => {
		this.setState({
			estoque: {
				...values,
				documento: documento.data.data
			}
		});
	};

	handleChangeSelect = (id, listName) => {
		if (id === "") {
			listName === "estoques"
				? this.setState({ saldo: "" })
				: this.setState({ municipio: "", dataEvento: "" });
			return;
		}

		// eslint-disable-next-line
		let listItem = this.state[listName].find(x => x.id == id);

		listName === "estoques"
			? this.setState({ saldo: listItem.quantidadeDisponivel })
			: this.setState({
					municipio: listItem.municipio.nome,
					dataEvento: listItem.data
			  });
	};

	/*
		Filtra estoques, para não receber nem ARP e nem Compra emergencial como estoques na saída
	*/
	filterEstoque() {
		const { estoques } = this.state;
		const estoquesFiltrados = estoques.filter(
			estoque =>
				estoque.tipoEstoque !== "ARP" &&
				estoque.tipoEstoque !== "COMPRA_EMERGENCIAL" &&
				estoque.quantidadeDisponivel > 0
		);
		return estoquesFiltrados;
	}

	onChangeOcorrencia(item) {
		const newState = this.state;
		newState.ocorrenciaSelecionadaId = item.object;
		newState.estoque.ocorrencia.id = item.object.id;
		this.setState(newState);
	}

	onChangeTipoEstoque(item) {
		const newState = this.state;
		newState.tipoEstoqueSelecionadoId = item.object;
		newState.estoque.id = item.object.id;
		this.setState(newState);
	}

	onChangeInput(item, nomeCampo) {
		const { estoque } = this.state;

		if (nomeCampo === "quantidade") {
			this.setState({
				estoque: { ...estoque, quantidadeSaida: item.target.value }
			});
		} else if (nomeCampo === "motivo") {
			this.setState({
				estoque: { ...estoque, motivo: item.target.value }
			});
		}
	}

	render() {
		const {
			props: {
				isOpenSaida,
				handleCloseSaida,
				handleSubmitSaida,
				nomeDaca
			},
			state: {
				files,
				estoque,
				validationSchema,
				ocorrenciaSelecionadaId,
				tipoEstoqueSelecionadoId,
				ocorrencias
			}
		} = this;
		return (
			<WidgetModalForm
				textCancelar="Cancelar"
				textConfirmar="Cadastrar"
				validationSchema={validationSchema}
				title="Registrar saída"
				confirmar={handleSubmitSaida}
				isOpen={isOpenSaida}
				initialValues={estoque}
				cancelar={handleCloseSaida}
				modalConfirmarFechar
				modalConfirmarCancelar
				modalConfirmarCancelarTitulo="Atenção!"
				modalConfirmarCancelarCorpo="Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos."
				iconCancelar="fas fa-times"
				iconConfirmar="fas fa-save"
			>
				<ModalFormContext.Consumer>
					{({ values, handleChange, setFieldValue }) => (
						<React.Fragment>
							<div className="row">
								<div className="col-12">
									<p>
										<strong>Item:</strong> {nomeDaca}{" "}
									</p>
								</div>
								<div className="col-md-12">
									<label>
										A retirada é para atender ocorrência?{" "}
										<Required />
									</label>
									<div className="form-group">
										<div className="form-check form-check-inline">
											<Input
												id="radio_1"
												name="isEvento"
												type="radio"
												value="true"
												className="form-check-input"
												onChange={value =>
													this.onChangeTipoOficio(
														value
													)
												}
											/>
											<label
												htmlFor="radio_1"
												className="form-check-label pointer-text"
											>
												Sim
											</label>
										</div>
										<div className="form-check form-check-inline">
											<Input
												id="radio_2"
												name="isEvento"
												type="radio"
												value="false"
												className="form-check-input"
												onChange={value =>
													this.onChangeTipoOficio(
														value
													)
												}
											/>
											<label
												htmlFor="radio_2"
												className="form-check-label pointer-text"
											>
												Não
											</label>
										</div>
									</div>
									<ErrorMessage
										name="isEvento"
										render={msg => (
											<span className="text-danger">
												{msg}
											</span>
										)}
									/>
								</div>
							</div>

							{/* EVENTO */}
							{estoque.isEvento === "true" && (
								<React.Fragment>
									<div className="row">
										<div className="col-md-12">
											<label>
												Ocorrência: <Required />
											</label>
											<div className="form-group">
												<SelectMulti
													label="nome"
													name="ocorrencia.id"
													className="form-control form-control-sm"
													onChange={item => {
														this.onChangeOcorrencia(
															item
														);
														handleChange(
															item.value
														);
														this.handleChangeSelect(
															item.value,
															"ocorrencias"
														);
													}}
													value={
														ocorrenciaSelecionadaId ||
														estoque.ocorrencia.id
													}
													options={ocorrencias}
												/>
												<ErrorMessage
													name="ocorrencia.id"
													render={msg => (
														<div className="mb-1 mt-0">
															<span className="text-danger">
																{" "}
																{msg}
															</span>
														</div>
													)}
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-6">
											<label>Município:</label>
											<div className="form-group">
												{this.state.municipio || "--"}
											</div>
										</div>

										<div className="col-md-6">
											<label>Data do evento:</label>

											<div className="form-group">
												{this.state.dataEvento || "--"}
											</div>
										</div>
									</div>
								</React.Fragment>
							)}

							{/* COMUM */}
							{estoque.isEvento !== undefined && (
								<React.Fragment>
									<div className="row">
										<div className="col-md-6">
											<label>
												Tipo de estoque: <Required />
											</label>

											<div className="form-group">
												<SelectMulti
													label="nomeTipoEstoque"
													name="id"
													className="form-control form-control-sm"
													onChange={item => {
														this.onChangeTipoEstoque(
															item
														);
														handleChange(
															item.value
														);
														this.handleChangeSelect(
															item.value,
															"estoques"
														);
													}}
													value={
														tipoEstoqueSelecionadoId ||
														values.id
													}
													options={this.filterEstoque()}
												/>
												<ErrorMessage
													name="id"
													render={msg => (
														<div className="mb-1 mt-0">
															<span className="text-danger">
																{" "}
																{msg}
															</span>
														</div>
													)}
												/>
											</div>
										</div>

										<div className="col-md-6">
											<label>Saldo:</label>

											<div className="form-group">
												{this.state.saldo || "--"}
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-6">
											<label>
												Quantidade: <Required />
											</label>
											<div className="form-group">
												<Input
													maxLength="18"
													type="text"
													mask={numberMask}
													name="quantidadeSaida"
													onChange={event => {
														handleChange(event);
														this.onChangeInput(
															event,
															"quantidade"
														);
													}}
													value={
														values.quantidadeSaida
													}
												/>
												<ErrorMessage
													name="quantidadeSaida"
													render={msg => (
														<div className="mb-1 mt-0">
															<span className="text-danger">
																{" "}
																{msg}
															</span>
														</div>
													)}
												/>
											</div>
										</div>
									</div>
								</React.Fragment>
							)}

							{/* NÃO É EVENTO */}
							{estoque.isEvento === "false" && (
								<React.Fragment>
									<div className="row">
										<div className="col-md-12">
											<label>
												Motivo: <Required />
											</label>
										</div>
										<div className="container-fluid">
											<Input
												name="motivo"
												type="textarea"
												onChange={event => {
													handleChange(event);
													this.onChangeInput(
														event,
														"motivo"
													);
												}}
												value={values.motivo}
											/>
											<ErrorMessage
												name="motivo"
												render={msg => (
													<span className="text-danger">
														{msg}
													</span>
												)}
											/>
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">
											<label>
												Termo de recebimento:{" "}
												<Required />
											</label>
										</div>
										<div className="container">
											<UploadBrowseFile
												name="documento"
												files={files}
												context={this}
												aspectRatio={0.1}
												valuesFormik={values}
												expetedTypesLabel="Selecione arquivos de texto ou imagens"
												onUpload={
													this.handlePosUploadAction
												}
												handleUploadFile={
													UploadService.handleUploadFilePond
												}
												acceptedFileTypes={[
													"application/pdf",
													"application/msword",
													"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
													"image/png",
													"image/jpeg",
													"image/jpg",
													"image/bmp",
													"image/tiff"
												]}
												handleRemoveFile={() => {
													this.setState(
														prevState => ({
															files: [],
															estoque: {
																...prevState.estoque,
																documento: ""
															}
														})
													);
												}}
											/>
											<ErrorMessage
												name="documento"
												render={msg => (
													<span className="text-danger">
														{msg}
													</span>
												)}
											/>
										</div>
									</div>
								</React.Fragment>
							)}
						</React.Fragment>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}
